import { render } from "./ImageSerializer.vue?vue&type=template&id=1106bd96&scoped=true"
import script from "./ImageSerializer.vue?vue&type=script&lang=js"
export * from "./ImageSerializer.vue?vue&type=script&lang=js"

import "./ImageSerializer.vue?vue&type=style&index=0&id=1106bd96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1106bd96"]])

export default __exports__